import type { Extractor } from "../types.js";

export const extractVoid: Extractor = () => ({ type: "void" });
